import type {Recipe} from './types';

export const muffinAllaBananaECioccolato: Recipe = {
    id: 19,
    key: "muffinAllaBananaECioccolato",
    pictures: [
        {index: 0, url: "https://blog.giallozafferano.it/cuochinprogress/wp-content/uploads/2020/03/muffin-banane-e-gocce-di-cioccolato-720x935.jpg"},
    ],
    i18n: {
        IT: {
            title: "Muffin alla Banana e Cioccolato",
            servings: "12 muffin",
            ingredients: [
                "2 tazze di farina di grano",
                "un pizzico di sale",
                "1 cucchiaino di lievito in polvere",
                "1 cucchiaino di bicarbonato di sodio",
                "0.5 tazza di zucchero di canna",
                "5 quadrati di cioccolato fondente",
                "2 uova",
                "0.5 tazza di olio",
                "2 banane mature (circa 250 g dopo la sbucciatura)",
            ],
            steps: [
                "Portare le uova a temperatura ambiente.",
                "Mescolare gli ingredienti secchi (farina, sale, lievito, bicarbonato di sodio, zucchero di canna).",
                "Tagliare il cioccolato a pezzi e mescolarlo con la farina.",
                "Sbattere le uova con una forchetta e mescolarle.",
                "Schiacciare le banane con una forchetta e aggiungerle alle uova insieme all'olio, quindi mescolare.",
                "Aggiungere gli ingredienti secchi agli ingredienti umidi e mescolare fino a ottenere un composto omogeneo.",
                "Versare l'impasto in 12 stampini per muffin.",
                "Cuocere a 180°C per 25 minuti (senza preriscaldare il forno).",
                "Rimuovere dal forno e far raffreddare su una griglia.",
            ],
        },
        EN: {
            title: "Banana and Chocolate Muffins",
            servings: "12 muffins",
            ingredients: [
                "2 cups of wheat flour",
                "a pinch of salt",
                "1 teaspoon of baking powder",
                "1 teaspoon of baking soda",
                "0.5 cup of brown sugar",
                "5 squares of dark chocolate",
                "2 eggs",
                "0.5 cup of oil",
                "2 ripe bananas (about 250 g after peeling)",
            ],
            steps: [
                "Bring the eggs to room temperature.",
                "Mix the dry ingredients (flour, salt, baking powder, baking soda, brown sugar).",
                "Cut the chocolate into pieces and mix it with the flour.",
                "Beat the eggs with a fork and mix them.",
                "Mash the bananas with a fork and add them to the eggs along with the oil, then mix.",
                "Add the dry ingredients to the wet ingredients and mix until you get a homogeneous mixture.",
                "Pour the batter into 12 muffin molds.",
                "Bake at 180°C for 25 minutes (without preheating the oven).",
                "Remove from the oven and cool on a rack.",
            ],
        },
        PL: {
            title: "Muffinki Bananowo-Czekoladowe",
            servings: "12 muffinek",
            ingredients: [
                "2 szklanki mąki pszennej",
                "szczypta soli",
                "1 łyżeczka proszku do pieczenia",
                "1 łyżeczka sody oczyszczonej",
                "0,5 szklanki brązowego cukru",
                "5 kostek ciemnej czekolady",
                "2 jajka",
                "0,5 szklanki oleju",
                "2 dojrzałe banany (około 250 g po obraniu)",
            ],
            steps: [
                "Doprowadź jajka do temperatury pokojowej.",
                "Wymieszaj suche składniki (mąka, sól, proszek do pieczenia, soda oczyszczona, brązowy cukier).",
                "Pokrój czekoladę na kawałki i wymieszaj z mąką.",
                "Roztrzep jajka widelcem i wymieszaj.",
                "Rozgnieć banany widelcem i dodaj do jajek wraz z olejem, następnie wymieszaj.",
                "Dodaj suche składniki do mokrych i mieszaj, aż uzyskasz jednolitą masę.",
                "Wlej ciasto do 12 foremek na muffinki.",
                "Piecz w 180°C przez 25 minut (bez nagrzewania piekarnika).",
                "Wyjmij z piekarnika i ostudź na kratce.",
            ],
        },
    },
};
